import { createTooltip as i, destroyTooltip as r } from "v-tooltip";
import { warn as d } from "../../utils/console.js";
const l = "position:fixed;pointer-events:none;z-index:-9999;opacity:0;", a = "Failed to copy to clipboard.", u = "Copied!", p = (t) => {
  const e = document.createElement("textarea");
  let o;
  if (typeof t.dataset.value != "string")
    try {
      o = JSON.stringify(t.dataset.value);
    } catch {
      throw a;
    }
  else
    o = t.dataset.value;
  e.value = o, e.setAttribute("readonly", ""), e.style.cssText = l, t.appendChild(e), e.select();
  let n = !1;
  try {
    n = document.execCommand("copy");
  } catch (s) {
    d(s);
  }
  return t.removeChild(e), n;
};
function c(t) {
  if (t.dataset.value) {
    const o = i(t, { content: null, trigger: "manual", classes: "pendo-tooltip has-tooltip-arrow", offset: 8 }, {});
    p(t) ? o.setContent(u) : o.setContent(a), o.show(), t.addEventListener("mouseleave", function n() {
      o.hide(), r(t), t.removeEventListener("mouseleave", n);
    });
  }
}
function v(t, { value: e }) {
  t.dataset.value = e, t.setAttribute("title", "Copy to clipboard"), t.addEventListener("click", c.bind(null, t));
}
function f(t, { oldValue: e, value: o }) {
  o !== e && (t.dataset.value = o);
}
function m(t) {
  t.removeEventListener("click", c);
}
const C = {
  beforeMount: v,
  updated: f,
  unmounted: m
};
export {
  C as PendoClipboard,
  v as beforeMount,
  C as default,
  m as unmounted,
  f as updated
};
//# sourceMappingURL=pendo-clipboard.js.map
